import firebase from "firebase";
import "@firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBHJBPbofn2lqZjQoedTricoMAPhvM_lBY",
  authDomain: "siampiwat-a6428.firebaseapp.com",
  projectId: "siampiwat-a6428",
  storageBucket: "siampiwat-a6428.appspot.com",
  messagingSenderId: "651953206704",
  appId: "1:651953206704:web:26a1560949315952859275"
};
export const authFirebase = firebase.initializeApp(firebaseConfig);
